// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceReportPage-cls1_IrP","cls2":"ReferenceReportPage-cls2_Axs ReferenceReportPage-cls1_IrP"};